import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const CartDrawer = ({ isOpen, onClose, cart, updateQuantity, removeItem }) => {
  const total = cart.reduce((acc, item) => acc + (item.price * item.quantity), 0);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-stone-900/40 backdrop-blur-sm z-[100]"
          />
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed top-0 right-0 h-full w-full max-w-md bg-stone-50 z-[110] shadow-2xl flex flex-col"
          >
            <div className="p-6 border-b border-stone-200 flex items-center justify-between">
              <h2 className="font-serif text-2xl">Your Bag</h2>
              <button 
                onClick={onClose}
                className="p-2 hover:bg-stone-100 rounded-full transition-colors"
                aria-label="Close cart"
              >
                <SafeIcon icon={FiIcons.FiX} className="w-6 h-6" />
              </button>
            </div>

            <div className="flex-grow overflow-y-auto p-6">
              {cart.length === 0 ? (
                <div className="h-full flex flex-col items-center justify-center text-center">
                  <SafeIcon icon={FiIcons.FiShoppingBag} className="w-12 h-12 text-stone-300 mb-4" />
                  <p className="text-stone-500 font-light mb-8">Your bag is currently empty.</p>
                  <button 
                    onClick={onClose}
                    className="text-xs font-bold tracking-widest uppercase border-b border-stone-900 pb-1"
                  >
                    Continue Browsing
                  </button>
                </div>
              ) : (
                <div className="space-y-8">
                  {cart.map((item) => (
                    <div key={item.id} className="flex gap-4">
                      <div className="w-24 h-32 bg-stone-200 overflow-hidden">
                        <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                      </div>
                      <div className="flex-grow">
                        <div className="flex justify-between items-start mb-1">
                          <h3 className="text-sm font-medium uppercase tracking-wide">{item.name}</h3>
                          <button onClick={() => removeItem(item.id)} className="text-stone-400 hover:text-stone-900">
                            <SafeIcon icon={FiIcons.FiTrash2} className="w-4 h-4" />
                          </button>
                        </div>
                        <p className="text-xs text-stone-500 mb-4">${item.price}</p>
                        <div className="flex items-center gap-3">
                          <button 
                            onClick={() => updateQuantity(item.id, item.quantity - 1)}
                            className="w-6 h-6 border border-stone-300 flex items-center justify-center text-xs"
                          >
                            -
                          </button>
                          <span className="text-xs font-medium">{item.quantity}</span>
                          <button 
                            onClick={() => updateQuantity(item.id, item.quantity + 1)}
                            className="w-6 h-6 border border-stone-300 flex items-center justify-center text-xs"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {cart.length > 0 && (
              <div className="p-6 bg-white border-t border-stone-200">
                <div className="flex justify-between items-center mb-6">
                  <span className="text-sm font-medium uppercase tracking-widest">Subtotal</span>
                  <span className="text-lg font-serif">${total.toFixed(2)}</span>
                </div>
                <button className="w-full bg-stone-900 text-white py-4 text-xs font-bold tracking-[0.2em] uppercase hover:bg-stone-800 transition-colors">
                  Checkout
                </button>
                <p className="text-[10px] text-stone-400 text-center mt-4 tracking-widest">
                  SHIPPING & TAXES CALCULATED AT CHECKOUT
                </p>
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CartDrawer;